import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Reason } from 'packages/rum';
import NullComponent from 'app/components/NullComponent/NullComponent';
import noop from 'app/libs/noop';
import logError from 'app/error/logError';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidCatch(error, info) {
    try {
      this.props.onError(error, info.componentStack);
    } catch (error) {} // eslint-disable-line no-empty

    logError(error, { ...info, reason: Reason.Render });

    this.setState({ error, info });
  }

  render() {
    const { error, info } = this.state;

    if (error) {
      const { FallbackComponent } = this.props;

      return (
        <FallbackComponent error={error} componentStack={info.componentStack} />
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  FallbackComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  onError: PropTypes.func,
};

ErrorBoundary.defaultProps = {
  FallbackComponent: NullComponent,
  onError: noop,
};

export default ErrorBoundary;
